import type { ThemeOverride } from '@chakra-ui/react';

export const sizes: ThemeOverride['sizes'] = {
   header: '68px',
};
